module.exports = __webpack_public_path__ + "img/logo.e06d0fc3.png";